import { FetchResult } from '@apollo/client'
import { client } from '../..'
import { Country } from '../../types'
import { DISABLE_RANKING_FOR_COMPANY_COUNTRY, ENABLE_RANKING_FOR_COMPANY_COUNTRY } from './Mutations'
import { IS_RANKING_ENABLED } from './Queries'

export const enableRanking = async (companyId: string, country: Country): Promise<FetchResult> => {
  return await client.mutate({
    mutation: ENABLE_RANKING_FOR_COMPANY_COUNTRY,
    variables: {
      companyId,
      country,
    },
    refetchQueries: [
      {
        query: IS_RANKING_ENABLED,
        variables: {
          companyId,
          country,
        },
      },
    ],
  })
}

export const disableRanking = async (companyId: string, country: Country): Promise<FetchResult> => {
  return await client.mutate({
    mutation: DISABLE_RANKING_FOR_COMPANY_COUNTRY,
    variables: {
      companyId,
      country,
    },
    refetchQueries: [
      {
        query: IS_RANKING_ENABLED,
        variables: {
          companyId,
          country,
        },
      },
    ],
  })
}
